import { fetchRequestSend } from '../../helpers/common-helpers';
import PopupClass from '../common/PopupClass';

export default class DemoVideoHubspotSync {
    constructor() {
        this.email = null;
        this.popupClassInit = new PopupClass();
        this.demoVideoId = 'demo-video';

        this.init();
    }

    init() {
        const pageURLGetParams = window.location.search.substring(1);

        if (pageURLGetParams) {
            const demoToken = this.getUrlParam('cg_token', pageURLGetParams);

            if (demoToken) {
                // Convert base64 to string
                this.email = atob(demoToken.trim());
                this.addEventListeners();
            }
        }

        this.openDemoPopupByParameter();
    }

    openDemoPopupByParameter() {
        const url = new URL(window.location.href);
        const mode = url.searchParams.get('demo');
        const demoPopup = document.getElementById(this.demoVideoId);

        if (demoPopup && mode) {
            const iframe = demoPopup.querySelector('iframe');

            iframe.src = `/demo/${mode}/index.html`;
            this.popupClassInit.open(this.demoVideoId);
        }
    }

    addEventListeners() {
        window.addEventListener('message', (event) => {
            const demoStatusMap = {
                'onDemoStart': 'Start',
                'onDemoComplete': 'Complete'
            };

            if (demoStatusMap[event.data]) {
                this.sendDemoStatusUpdate(demoStatusMap[event.data]);
            }
        });
    }

    sendDemoStatusUpdate(status) {
        const jsonContent = JSON.stringify({
            'email': this.email,
            'demo_status': status,
        });

        fetchRequestSend(updateDemoStatusUrl, 'POST', jsonContent);
    }

    getUrlParam(param, pageURL) {
        const urlVariables = pageURL.split('&');

        for (const variable of urlVariables) {
            const [name, value] = variable.split('=');

            if (name === param) {
                return value ? decodeURIComponent(value) : null;
            }
        }

        return null;
    };
}
